export enum ProjectApplicantStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  INTERVIEWING = 'INTERVIEWING',
  DECLINED = 'DECLINED',
}

export const PROJECT_APPLICANT_STATUS_MAP = {
  [ProjectApplicantStatus.PENDING]: 'Pending',
  [ProjectApplicantStatus.ACCEPTED]: 'Accepted',
  [ProjectApplicantStatus.INTERVIEWING]: 'Interviewing',
  [ProjectApplicantStatus.DECLINED]: 'Declined'
};